// Sugalarm — /api/treatments wrappers.

import { request } from "../lib/apiClient";
import type {
  ApiResult,
  Treatment,
  TreatmentCreateIn,
  TreatmentUpdateIn,
} from "../lib/types";

export interface TreatmentListResponse {
  count: number;
  treatments: Treatment[];
}

export interface ListOpts {
  hours?: number; // default 4
  limit?: number; // default 50
  before?: string; // ISO-8601 UTC; default omitted (cycle 31)
}

export function list(
  hoursOrOpts?: number | ListOpts,
  limit?: number,
): Promise<ApiResult<TreatmentListResponse>> {
  let hoursParam: number;
  let limitParam: number;
  let beforeParam: string | undefined;
  if (typeof hoursOrOpts === "object" && hoursOrOpts !== null) {
    hoursParam = hoursOrOpts.hours ?? 4;
    limitParam = hoursOrOpts.limit ?? 50;
    beforeParam = hoursOrOpts.before;
  } else {
    hoursParam = hoursOrOpts ?? 4;
    limitParam = limit ?? 50;
  }
  const qs = new URLSearchParams({
    hours: String(hoursParam),
    limit: String(limitParam),
  });
  if (beforeParam) qs.set("before", beforeParam);
  return request<TreatmentListResponse>(`/api/treatments?${qs.toString()}`);
}

export function create(body: TreatmentCreateIn): Promise<ApiResult<Treatment>> {
  return request<Treatment>("/api/treatments", { method: "POST", body });
}

// Cycle 34.20: partial update on an existing treatment row. Server
// broadcasts the cycle-24 `treatment` WS frame so every consumer
// (BolusRings, dashboard cards, recent-entries strip, etc.) upserts
// in place — the IOB timer responds without any extra frame plumbing.
export function update(
  id: string,
  body: TreatmentUpdateIn,
): Promise<ApiResult<Treatment>> {
  return request<Treatment>(`/api/treatments/${id}`, {
    method: "PATCH",
    body,
  });
}

export function remove(id: string): Promise<ApiResult<void>> {
  return request<void>(`/api/treatments/${id}`, { method: "DELETE" });
}
